// Author Lin
// Date 2024-10-25 17:09:13

class SithMesInventoryStorageInput {
    constructor({
                    id = null,
                    inputListType = '',
                    poItemId = '',
                    prdHeaderId = '',
                    lastOperationId = '',
                    inputType = '',
                    inputQuantity = '',
                    storageId = '',
                    storageType = '',
                    binCode = '',
                    binOccupiedCapacity = '',
                    inputApplyTime = '',
                    applicantId = '',
                    applicantName = '',
                    inputActualTime = '',
                    inputActualPersonId = '',
                    name = '',
                    sendSapStatus = '',
                    remark = '',
                    updatedTime = ''
                }
                    = {}) {
        this.id = id;
        this.inputListType = inputListType;
        this.poItemId = poItemId;
        this.prdHeaderId = prdHeaderId;
        this.lastOperationId = lastOperationId;
        this.inputType = inputType;
        this.inputQuantity = inputQuantity;
        this.storageId = storageId;
        this.storageType = storageType;
        this.binCode = binCode;
        this.binOccupiedCapacity = binOccupiedCapacity;
        this.inputApplyTime = inputApplyTime;
        this.applicantId = applicantId;
        this.applicantName = applicantName;
        this.inputActualTime = inputActualTime;
        this.inputActualPersonId = inputActualPersonId;
        this.name = name;
        this.sendSapStatus = sendSapStatus;
        this.remark = remark;
        this.updatedTime = updatedTime;
    }
}

function newEntity() {
    return new SithMesInventoryStorageInput();
}

const purchaseVoConfigs = [
    {
        key: 'inputListType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputListType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '生产完工产品入库'},
                {value: '2', text: '进货入库'}
            ]
        }
    },
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.purchaseNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.itemCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poProjectNumber',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poProjectNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poProjectName',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poProjectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemMaterialCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poItemMaterialCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemMaterialDesc',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poItemMaterialDesc',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterial',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.packingMaterial',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.quantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputQuantity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.unit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'soNumber',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.soNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'soItem',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.soItem',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCategory',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.itemCategory',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemCategory',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poItemCategory',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.projectWbs',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.vendorNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageArea',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageArea',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'applicant',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.applicant',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputApplyTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageType',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageName',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.binCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binOccupiedCapacity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.binOccupiedCapacity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputActualTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastReturn106Time',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.lastReturn106Time',
        sortable: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputPerson',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputPerson',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sendSapStatus',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.sendSapStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.updatedTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inputListType',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputListType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '生产完工产品入库'},
                    {value: '2', text: '进货入库'}
                ]
            }
        },
        {
            key: 'purchaseNumber',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.purchaseNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemCode',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.itemCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectNumber',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.projectNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poProjectNumber',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poProjectNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poProjectName',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poProjectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderType',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.orderType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItemMaterialCode',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poItemMaterialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItemMaterialDesc',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poItemMaterialDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packingMaterial',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.packingMaterial',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderQuantity',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.orderQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrder',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.salesOrder',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrderItem',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.salesOrderItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inputQuantity',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'soNumber',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.soNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'soItem',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.soItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemCategory',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.itemCategory',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItemCategory',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.poItemCategory',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectWbs',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.projectWbs',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNumber',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.vendorNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageArea',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageArea',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageAreaPp',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageAreaPp',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationSeq',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.operationSeq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'location',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.location',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inputType',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '虚入'},
                    {value: '1', text: '实入'}
                ]
            }
        },
        {
            key: 'applicant',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.applicant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inputApplyTime',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputApplyTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageType',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageName',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'binCode',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.binCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'binOccupiedCapacity',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.binOccupiedCapacity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inputActualTime',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputActualTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inputPerson',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputPerson',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sendSapStatus',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.sendSapStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '成功'},
                    {value: '1', text: '失败'},
                    {value: '2', text: '未回传'},
                    {value: '3', text: 'NULL'}
                ]
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.remark',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'updatedTime',
            label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.updatedTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const productsVoConfigs = [
    {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.id',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input'
        }
    },
    {
        key: 'inputListType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputListType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '生产完工产品入库'},
                {value: '2', text: '进货入库'}
            ]
        }
    },
    {
        key: 'projectNumber',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.projectNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.orderType',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.materialDescription',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderQuantity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.orderQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrder',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.salesOrder',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderItem',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.salesOrderItem',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageAreaPp',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageAreaPp',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.operationSeq',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'location',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.location',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'applicant',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.applicant',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputApplyTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageType',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageName',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.storageName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.binCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binOccupiedCapacity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.binOccupiedCapacity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputActualTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputPerson',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.inputPerson',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sendSapStatus',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.sendSapStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.grid.updatedTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idListFilter: [],
    inputListTypeFilter: '',
    poItemIdFilter: '',
    purchaseNumberFilter: '',
    itemCodeFilter: '',
    poItemMaterialCodeFilter: '',
    packingMaterialFilter: '',
    storageAreaFilter: '',
    storageAreaPpFilter: '',
    prdHeaderIdFilter: '',
    orderCodeFilter: '',
    materialCodeFilter: '',
    inputTypeFilter: '',
    inputQuantityFilter: '',
    storageIdFilter: '',
    storageTypeFilter: '',
    binCodeFilter: '',
    binOccupiedCapacityFilter: '',
    inputApplyTimeRteFilter: '',
    inputApplyTimeLteFilter: '',
    applicantIdFilter: '',
    inputActualTimeRteFilter: '',
    inputActualTimeLteFilter: '',
    inputActualPersonIdFilter: '',
    sendSapStatusFilter: '',
    sendSapStatusIsNullFilter: '',
    updatedTimeRteFilter: '',
    updatedTimeLteFilter: '',
    hasLastReturn106TimeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'inputListTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputListType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产完工产品入库'},
                {value: '2', text: '进货入库'}
            ]
        }
    },
    {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.purchaseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemMaterialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.poItemMaterialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageAreaFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.storageArea',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageAreaPpFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.storageAreaPp',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdHeaderIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.prdHeaderId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'storageIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.storageId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryWmDefinition'
            , correspondingField: 'id'
        }
    },
    {
        key: 'binCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.binCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputApplyTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputApplyTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.applicantId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inputActualTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualPersonIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualPersonId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'sendSapStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.sendSapStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'updatedTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.updatedTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.updatedTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const purchaseFilterConfigs = [
    {
        key: 'inputListTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputListType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产完工产品入库'},
                {value: '2', text: '进货入库'}
            ]
        }
    },
    {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.purchaseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemMaterialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.poItemMaterialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageAreaFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.storageArea',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'storageIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.storageId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryWmDefinition'
            , correspondingField: 'id'
        }
    },
    {
        key: 'binCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.binCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputApplyTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputApplyTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.applicantId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inputActualTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualPersonIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualPersonId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'sendSapStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.sendSapStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'updatedTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.updatedTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.updatedTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'hasLastReturn106TimeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.hasLastReturn106Time',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];
const productsFilterConfigs = [
    {
        key: 'storageAreaPpFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.storageAreaPp',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdHeaderIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.prdHeaderId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'storageIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.storageId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryWmDefinition'
            , correspondingField: 'id'
        }
    },
    {
        key: 'binCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.binCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputApplyTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputApplyTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.applicantId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inputActualTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputActualPersonIdFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.inputActualPersonId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'sendSapStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.sendSapStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'updatedTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.updatedTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.filter.updatedTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const purchaseEntityConfigs = [
    {
        key: 'inputListType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputListType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产完工产品入库'},
                {value: '2', text: '进货入库'}
            ]
        }
    },
    {
        key: 'poItemId',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.poItemId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryItem'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inputType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'inputQuantity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryWmDefinition'
            , correspondingField: 'storageType'
            , fieldsBindingByEntityModalSelected: '{"storageId":"id"}'
        }
    },
    {
        key: 'binCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.binCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binOccupiedCapacity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.binOccupiedCapacity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputApplyTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantName',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.applicantName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"applicantId":"id"}'
        }
    },
    {
        key: 'inputActualTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputActualTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'name',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"inputActualPersonId":"id"}'
        }
    },
    {
        key: 'sendSapStatus',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.sendSapStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'updatedTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.updatedTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
]
const entityFormConfigs = [
    {
        key: 'inputListType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputListType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产完工产品入库'},
                {value: '2', text: '进货入库'}
            ]
        }
    },
    {
        key: 'poItemId',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.poItemId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryItem'
            , correspondingField: 'id'
        }
    },
    {
        key: 'prdHeaderId',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.prdHeaderId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'lastOperationId',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.lastOperationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpOperation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inputType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'inputQuantity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryWmDefinition'
            , correspondingField: 'storageType'
            , fieldsBindingByEntityModalSelected: '{"storageId":"id"}'
        }
    },
    {
        key: 'binCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.binCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binOccupiedCapacity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.binOccupiedCapacity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputApplyTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantName',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.applicantName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"applicantId":"id"}'
        }
    },
    {
        key: 'inputActualTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputActualTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'name',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"inputActualPersonId":"id"}'
        }
    },
    {
        key: 'sendSapStatus',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.sendSapStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.updatedTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
]
const productsEntityConfigs = [
    {
        key: 'inputListType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputListType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产完工产品入库'},
                {value: '2', text: '进货入库'}
            ]
        }
    },
    {
        key: 'prdHeaderId',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.prdHeaderId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'lastOperationId',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.lastOperationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpOperation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inputType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '虚入'},
                {value: '1', text: '实入'}
            ]
        }
    },
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryWmDefinition'
            , correspondingField: 'storageType'
            , fieldsBindingByEntityModalSelected: '{"storageId":"id"}'
        }
    },
    {
        key: 'binCode',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.binCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binOccupiedCapacity',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.binOccupiedCapacity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inputApplyTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputApplyTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantName',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.applicantName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"applicantId":"id"}'
        }
    },
    {
        key: 'inputActualTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.inputActualTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'name',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"inputActualPersonId":"id"}'
        }
    },
    {
        key: 'sendSapStatus',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.sendSapStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '成功'},
                {value: '1', text: '失败'},
                {value: '2', text: '未回传'},
                {value: '3', text: 'NULL'}
            ]
        }
    },
    {
        key: 'updatedTime',
        label: 'label.sith.inventory.sithMesInventoryStorageInput.entity.updatedTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesInventoryStorageInput, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, purchaseFilterConfigs, productsFilterConfigs
    , purchaseEntityConfigs, productsEntityConfigs
    , purchaseVoConfigs, productsVoConfigs
}
